import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";

import {
  Box,
  Button,
  Checkbox,
  Chip,
  FilledInput,
  FormControl,
  IconButton,
  Input,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import moment from "moment";
import { useEffect, useState } from "react";
import DataTableItem from "react-data-table-component";
import localizationStrings from "../utils/localizations";
import { baseUrl } from "../utils/constants";
import "./Companies.css";

export default function TimeAttendance() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [roles, setRoles] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [currentSelected, setSelected] = useState(null);
  const [name, setName] = useState("");
  const [loginId, setLoginId] = useState("");
  const [password, setPassword] = useState("");
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [modalLoading, setModalLoading] = useState(false);
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [timeToUpdate, setTimeToUpdate] = useState("");
  const [officeLat, setOfficeLat] = useState("");
  const [officeLng, setOfficeLng] = useState("");
  const [radius, setRadius] = useState("");
  const [radiusToRemove, setRadiusToRemove] = useState("");
  const [officeName, setOfficeName] = useState("");
  const [type, setType] = useState(0);

  const handleOpen = (item) => {
    setSelected(item);
    setTimeToUpdate(item.update_time);
    setOfficeLat(item.office_lat);
    setOfficeLng(item.office_lng);
    setRadius(item.radius);
    setType(item.isEmployee);
    setRadiusToRemove(item.radiusToRemove);
    setOfficeName(item.office_name);
    setModalVisible(true);
  };
  const handleClose = () => {
    setSelected(null);
    setTimeToUpdate("");
    setOfficeLat("");
    setOfficeLng("");
    setRadius("");
    setRadiusToRemove("");
    setOfficeName("");
    setType(0);
    setModalVisible(false);
  };

  const getTimeAttendanceValues = async (silent = false) => {
    if (!silent) setLoading(true);
    try {
      const data = await axios.get(baseUrl + "getTimeAttendanceValues");
      if (data.data.status) {
        setData(data.data.result);
        setFilteredData(data.data.result);
      }
      if (!silent) setLoading(false);
    } catch (e) {
      if (!silent) setLoading(false);
      console.warn(e);
    }
  };
  useEffect(() => {
    getTimeAttendanceValues();
    const int = setInterval(() => {
      getTimeAttendanceValues(true);
    }, 60 * 1000);
    return () => clearInterval(int);
  }, []);

  const pressSave = async () => {
    setModalLoading(true);
    try {
      const body = {
        update_time: timeToUpdate,
        office_lat: officeLat,
        office_lng: officeLng,
        radius: radius,
        isEmployee: type,
        admin_login_id: JSON.parse(localStorage.getItem("user") || "{}").login_id,
        radiusToRemove,
        office_name: officeName,
      };
      if (currentSelected) body["id"] = currentSelected.id;
      await axios.post(baseUrl + (currentSelected ? "editTimeAttendance" : "saveTimeAttendance"), body);
      await getTimeAttendanceValues(true);
      setModalLoading(false);
      handleClose();
    } catch (e) {
      setModalLoading(false);
      console.warn(e);
    }
  };

  if (loading) {
    return (
      <div className="tracking-container" style={{ alignItems: "center", justifyContent: "center" }}>
        <div className="loader"></div>
      </div>
    );
  }
  if (data.length === 0) {
    return (
      <div className="tracking-container" style={{ alignItems: "center", justifyContent: "center" }}>
        <h3 style={{ textAlign: "center" }}>{localizationStrings.NoTrips}</h3>
      </div>
    );
  }

  const handleSearch = () => {
    setFilteredData(data.filter((v) => JSON.stringify(v).toLocaleLowerCase().includes(search.toLocaleLowerCase())));
  };

  return (
    <div style={{ height: "calc(100vh - 80px)", width: "100%", padding: 30 }}>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSearch();
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            mb: "15px",
          }}
        >
          {/* <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }} onClick={() => setModalVisible(true)}> */}
          <Button variant="contained" onClick={() => setModalVisible(true)}>
            {localizationStrings.Add}
          </Button>
          {/* </Box> */}
          <div style={{ flex: 1, display: "flex" }} />
          <Input
            style={{ backgroundColor: "#fff" }}
            placeholder={localizationStrings.Search}
            color="primary"
            value={search}
            onChange={(e) => setSearch(e.nativeEvent.target.value)}
            endAdornment={
              <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                <IconButton
                  onClick={() => {
                    setFilteredData(data);
                    setSearch("");
                  }}
                >
                  <CloseIcon />
                </IconButton>
                <IconButton type="submit" onClick={handleSearch}>
                  <SearchIcon />
                </IconButton>
              </Box>
            }
          />
        </Box>
      </form>
      <DataTableItem
        data={filteredData}
        columns={[
          {
            selector: (row) => row.office_name,
            name: <div>{localizationStrings.OfficeName}</div>,
            sortable: true,
            grow: 1,
            wrap: true,
          },
          {
            selector: (row) => row.update_time,
            name: <div>{localizationStrings.TimeToUpdate}</div>,
            sortable: true,
            grow: 1,
            wrap: true,
          },
          {
            selector: (row) => row.office_lat,
            name: <div>{localizationStrings.OfficeLat}</div>,
            sortable: true,
            grow: 1,
            wrap: true,
          },
          {
            selector: (row) => row.office_lng,
            name: <div>{localizationStrings.OfficeLng}</div>,
            sortable: true,
            grow: 1,
            wrap: true,
          },
          {
            selector: (row) => row.radius,
            name: <div>{localizationStrings.Radius}</div>,
            sortable: true,
            grow: 1,
            wrap: true,
          },
          {
            selector: (row) => row.radiusToRemove,
            name: <div>{localizationStrings.RadiusToRemove}</div>,
            sortable: true,
            grow: 1,
            wrap: true,
          },
          {
            selector: (row) => (row.isEmployee == 0 ? localizationStrings.Guidance : localizationStrings.Employees),
            name: <div>{localizationStrings.Type}</div>,
            sortable: true,
            grow: 1,
            wrap: true,
          },
          {
            selector: (row) => (
              <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "column", md: "column", lg: "row" } }}>
                {/* <Button variant='outlined' startIcon={<VisibilityIcon />}>
                  View
                </Button>
                <div style={{ width: 10, height: 10 }} /> */}
                <Button
                  style={{ color: "black" }}
                  variant="outlined"
                  startIcon={<EditIcon />}
                  onClick={() => handleOpen(row)}
                >
                  {localizationStrings.Edit}
                </Button>
                <div style={{ width: 10, height: 10 }} />
                <Button
                  style={{ color: "black" }}
                  variant="outlined"
                  startIcon={<DeleteIcon />}
                  onClick={() => {
                    // if (window.confirm("Are you sure you want to delete!")) {
                    //   setLoading(true);
                    //   axios
                    //     .post(baseUrl + "deleteAdmin", { id: row.id })
                    //     .then(() => getTimeAttendanceValues())
                    //     .catch(() => setLoading(false));
                    // }
                  }}
                >
                  {localizationStrings.Delete}
                </Button>
              </Box>
            ),
            name: <div>{localizationStrings.Options || "Options"}</div>,
            sortable: true,
            grow: 3,
            wrap: true,
          },
        ]}
        highlightOnHover
        fixedHeader
        pagination
        responsive
        style={{ height: "calc(100vh - 82px)" }}
        customStyles={{
          headCells: { style: { backgroundColor: "#E8DABC", color: "#000", fontSize: "11px" } },
          responsiveWrapper: { style: { height: "calc(100vh - 220px)" } },
          cells: { style: { fontSize: "11px" } },
        }}
        paginationComponent={({ rowsPerPage, rowCount, currentPage, onChangePage, onChangeRowsPerPage }) => (
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-end",
              minHeight: 56,
            }}
          >
            <Typography sx={{ margin: "0 24px", color: "rgba(0, 0, 0, 0.54)", fontSize: "13px" }}>
              {(currentPage - 1) * rowsPerPage + 1}-
              {currentPage * rowsPerPage > rowCount ? rowCount : currentPage * rowsPerPage} of {rowCount}
            </Typography>
            <div style={{ display: "flex", alignItems: "center" }}>
              <button
                className="changeButton"
                type="button"
                disabled={currentPage === 1}
                style={{
                  fill: `rgba(0,0,0,${currentPage === 1 ? "0.18" : "0.54"})`,
                  color: `rgba(0,0,0,${currentPage === 1 ? "0.18" : "0.54"})`,
                }}
                onClick={() => onChangePage(1)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                  role="presentation"
                >
                  <path d="M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"></path>
                  <path fill="none" d="M24 24H0V0h24v24z"></path>
                </svg>
              </button>
              <button
                className="changeButton"
                type="button"
                disabled={currentPage === 1}
                style={{
                  fill: `rgba(0,0,0,${currentPage === 1 ? "0.18" : "0.54"})`,
                  color: `rgba(0,0,0,${currentPage === 1 ? "0.18" : "0.54"})`,
                }}
                onClick={() => onChangePage(currentPage - 1)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                  role="presentation"
                >
                  <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path>
                  <path d="M0 0h24v24H0z" fill="none"></path>
                </svg>
              </button>
              <button
                className="changeButton"
                type="button"
                disabled={currentPage === Math.ceil(rowCount / rowsPerPage)}
                style={{
                  fill: `rgba(0,0,0,${currentPage === Math.ceil(rowCount / rowsPerPage) ? "0.18" : "0.54"})`,
                  color: `rgba(0,0,0,${currentPage === Math.ceil(rowCount / rowsPerPage) ? "0.18" : "0.54"})`,
                }}
                onClick={() => onChangePage(currentPage + 1)}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                  role="presentation"
                >
                  <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
                  <path d="M0 0h24v24H0z" fill="none"></path>
                </svg>
              </button>
              <button
                className="changeButton"
                type="button"
                disabled={currentPage === Math.ceil(rowCount / rowsPerPage)}
                style={{
                  fill: `rgba(0,0,0,${currentPage === Math.ceil(rowCount / rowsPerPage) ? "0.18" : "0.54"})`,
                  color: `rgba(0,0,0,${currentPage === Math.ceil(rowCount / rowsPerPage) ? "0.18" : "0.54"})`,
                }}
                onClick={() => onChangePage(Math.ceil(rowCount / rowsPerPage))}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                  role="presentation"
                >
                  <path d="M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"></path>
                  <path fill="none" d="M0 0h24v24H0V0z"></path>
                </svg>
              </button>
            </div>
          </Box>
        )}
      />
      {modalVisible && (
        <div className="modal-container">
          <div aria-hidden="true" className="modal-back" onClick={handleClose}></div>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: { xs: "90%", sm: "70%", md: "60%", lg: "40%", xl: "30%" },
              bgcolor: "background.paper",
              borderRadius: 1,
              boxShadow: 24,
              p: 4,
            }}
          >
            <Box
              sx={{
                position: "absolute",
                top: 20,
                [localizationStrings.getLanguage() === "ar" ? "left" : "right"]: 20,
              }}
            >
              <IconButton onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </Box>
            <Typography
              id="modal-modal-description"
              sx={{ mt: 5, textAlign: "center", fontWeight: "700", fontSize: 18 }}
            >
              {currentSelected ? localizationStrings.Edit : localizationStrings.Add}
            </Typography>
            <Box style={{ flex: 1, display: "flex", flexDirection: "column" }}>
              <div style={{ height: 20 }} />
              <TextField
                label={localizationStrings.TimeToUpdate}
                variant="filled"
                value={timeToUpdate}
                onChange={(e) => setTimeToUpdate(e.target.value)}
              />
              <div style={{ height: 20 }} />
              <TextField
                label={localizationStrings.OfficeName}
                variant="filled"
                value={officeName}
                onChange={(e) => setOfficeName(e.target.value)}
              />
              <div style={{ height: 20 }} />

              <TextField
                label={localizationStrings.OfficeLat}
                variant="filled"
                value={officeLat}
                onChange={(e) => setOfficeLat(e.target.value)}
              />
              <div style={{ height: 20 }} />
              <TextField
                label={localizationStrings.OfficeLng}
                variant="filled"
                value={officeLng}
                onChange={(e) => setOfficeLng(e.target.value)}
              />
              <div style={{ height: 20 }} />
              <TextField
                label={localizationStrings.Radius}
                variant="filled"
                value={radius}
                onChange={(e) => setRadius(e.target.value)}
              />
              <div style={{ height: 20 }} />
              <TextField
                label={localizationStrings.RadiusToRemove}
                variant="filled"
                value={radiusToRemove}
                onChange={(e) => setRadiusToRemove(e.target.value)}
              />
              <div style={{ height: 20 }} />

              <FormControl fullWidth variant="filled">
                <InputLabel id="demo-simple-select-label">{localizationStrings.Type}</InputLabel>
                <Select
                  value={type}
                  onChange={(e) => setType(e.target.value)}
                  input={<FilledInput label="Chip" />}
                  // renderValue={(selected) => (
                  //   <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                  //     {selected.map((value) => {
                  //       const label = (roles.find((v) => v.role_id == value)?.role_name || "")
                  //         .split("_")
                  //         .map((v) => v[0].toUpperCase() + v.slice(1))
                  //         .join(" ");
                  //       return <Chip key={value} label={label} />;
                  //     })}
                  //   </Box>
                  // )}
                >
                  {[
                    { id: 0, name: localizationStrings.Guidance },
                    { id: 1, name: localizationStrings.Employees },
                  ].map((val) => (
                    <MenuItem key={val.id} value={val.id} title={val.name}>
                      {/* <Checkbox checked={selectedRoles.indexOf(val.role_id) > -1} /> */}
                      <ListItemText
                        primaryTypographyProps={{
                          fontFamily: localizationStrings.getLanguage() === "en" ? "Aldrich" : "GESndBook",
                        }}
                        primary={val.name}
                      />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <div style={{ height: 20 }} />
              {modalLoading ? (
                <div style={{ alignItems: "center", justifyContent: "center", display: "flex" }}>
                  <div className="loader" />
                </div>
              ) : (
                <Button onClick={() => pressSave()} variant="contained">
                  {localizationStrings.Save}
                </Button>
              )}
              <div style={{ height: 20 }} />
            </Box>
          </Box>
        </div>
      )}
    </div>
  );
}
